import { useMemo } from 'react';

import { Navigate } from 'react-router-dom';

import { isLoggedInUser, LocalStorageKeys } from '@utils/auth';

type AuthenticatedRedirectProps = {
  to: string;
  fallback: React.ReactNode;
};

export const AuthenticatedRedirect = ({
  to,
  fallback,
}: AuthenticatedRedirectProps) => {
  const isAuthenticated = useMemo(() => isLoggedInUser(), []);

  const lastSelectedClient = localStorage.getItem(
    LocalStorageKeys.LAST_SELECTED_CLIENT,
  );

  return isAuthenticated && lastSelectedClient ? (
    <Navigate replace to={`/${lastSelectedClient}${to}`} />
  ) : (
    fallback
  );
};
